import { lazy } from "react";

const RoutePaths = [
  {
    path: "/",
    component: lazy(() => import("../homepage/Home/index")),
    meta: { title: "/", showInNavbar: true },
  },
  {
    path: "/home",
    component: lazy(() => import("../pages/Home/Home")),
    meta: { title: "Home", showInNavbar: true },
  },
  {
    path: "/about-us",
    component: lazy(() => import("../pages/AboutUs/AboutUs")),
    meta: { title: "About", showInNavbar: true },
  },
  {
    path: "/contact-us",
    component: lazy(() => import("../pages/ContactUs/ContactUs")),
    meta: { title: "Contact", showInNavbar: true },
  },
  {
    path: "/rooms",
    component: lazy(() => import("../pages/Rooms/Rooms")),
    meta: { title: "Rooms", showInNavbar: true },
  },
];

export default RoutePaths;
